'use strict';


import { AnimationMixer, Group, LinearSRGBColorSpace, Mesh, MeshBasicMaterial, TextureLoader } from 'three';
import {Cloudflare} from "../../../api/Cloudflare";

export class Cars {
    #active = config.features.liteMode.settings.cars?.active;
    #url = null;
    #loader = null;
    #ready = false;
    #group = new Group();
    #animationMixer = null;
    #speed = config.features.liteMode.settings.cars?.speed || 1.0;
    #position = config.features.liteMode.settings.cars?.position || { x:0, y:0, z:0 };
    #rotation = config.features.liteMode.settings.cars?.rotation || { x:0, y:0, z:0 };
    #scale = config.features.liteMode.settings.cars?.scale || { x:1, y:1, z:1 };
    #textureUrl;


    constructor (url,loader) {
        this.#url = `${url}${config.features.liteMode.settings.cars?.path}?v=${Cloudflare.version}` || '';
        this.#textureUrl = url + 'cars_lite_texture.jpg';
        this.#loader = loader;

        return this;
    }

    create() {
        if (!this.#active) return new Promise(resolve => resolve('disabled'));

        return new Promise(resolve => {
            this.#loader.load(this.#url, model => {
                const texture = new TextureLoader().load(this.#textureUrl);
                texture.colorSpace = LinearSRGBColorSpace;

                model.traverse(el => {
                   if (el.isMesh) {
                       // let color;
                       //
                       // if (this.#colors.length){
                       //     const randomValue = Math.floor(Math.random() * (this.#colors.length + 1));
                       //     const randomColor = this.#colors[randomValue];
                       //     color = new Color(randomColor);
                       // } else {
                       //     color = new Color('#000000');
                       // }

                       const geometry = el.geometry.clone();
                       const material = new MeshBasicMaterial({
                           depthTest: false,
                           depthWrite: false,
                           transparent: true,
                           map: texture
                       });
                       const mesh = new Mesh(geometry,material);
                       mesh.name = el.name;
                       mesh.position.copy(el.position);
                       mesh.rotation.copy(el.rotation);
                       mesh.scale.copy(el.scale);

                       this.#group.add(mesh);
                   }
                });

                const animations = model.animations;
                this.#animationMixer = new AnimationMixer(this.#group);

                animations.forEach(clip => {
                   this.#animationMixer.clipAction(clip).play();
                });

                // this.#group.rotation.set(Math.degToRad(-50),0,0);


               this.#group.rotation.set(this.#rotation.x,this.#rotation.y,this.#rotation.z);
               this.#group.position.set(this.#position.x,this.#position.y,this.#position.z);
               this.#group.scale.set(this.#scale.x,this.#scale.y,this.#scale.z);

                this.#group.name = 'cars';
                this.#ready = true;
                resolve(this.#group);
            });

        });
    }

    updateTime(time) {
        if (this.#ready) {
            this.#animationMixer.update(time * this.#speed * 1000);
        }
    }

    switcher(state) {
        if (this.#ready) {
            switch (state) {
                case 'show':
                    this.#group.visible = true;
                    break;
                case 'hide':
                    this.#group.visible = false;
                    break;
            }
        }
    }

}
